

function loginPage(){

const cognito = {
  domain: 'https://lewin-login-shared.auth.ap-southeast-2.amazoncognito.com',
  clientId: '15l3sgqeq20rubd4g0sggul9cp',
  userPoolId: 'ap-southeast-2_YuJR0QHSX'
}


    
   redirectToCognito()

    function base64urlEncode(str) {
      return btoa(String.fromCharCode(...new Uint8Array(str)))
        .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }

    async function generatePKCE() {
      const codeVerifier = base64urlEncode(crypto.getRandomValues(new Uint8Array(32)));
      const encoder = new TextEncoder();
      const data = encoder.encode(codeVerifier);
      const digest = await crypto.subtle.digest('SHA-256', data);
      const codeChallenge = base64urlEncode(digest);

      return { codeVerifier, codeChallenge };
    }
    async function redirectToCognito() {
      const domain = 'https://lewin-login-shared.auth.ap-southeast-2.amazoncognito.com'; // Replace with your domain
      const clientId = '15l3sgqeq20rubd4g0sggul9cp'; // Replace with your App client ID
      const redirectUri = `${window.origin}/main_nav.html`; // Replace with your actual redirect URI
      const responseType = 'code'; // or 'token' for implicit flow
      const scope = 'openid ';

		const { codeVerifier, codeChallenge } = await generatePKCE();
      sessionStorage.setItem('pkce_code_verifier', codeVerifier); 

   
      const url = `${domain}/oauth2/authorize` +
        `?response_type=${responseType}` +
        `&client_id=${clientId}` +
        `&redirect_uri=${encodeURIComponent(redirectUri)}` +
        `&scope=${encodeURIComponent(scope)}` +
        `&identity_provider=Microsoft`+
        `&code_challenge=${codeChallenge}` +
        `&code_challenge_method=S256`;

      window.location.href = url;
    }

return {
    redirectToCognito
}
}

const LP = loginPage();